import './chip.scss';

interface ICancelledChip {
	label?: string;
	title?: string;
}

/** "Cancelled" — the one mark every surface uses for a unit INEC cancelled. */
const CancelledChip = ({ label = 'Cancelled', title }: ICancelledChip) => (
	<span
		className='pu-cancelled pu-cancelled'
		title={title}
	>
		{label}
	</span>
);

export default CancelledChip;
